import * as React from "react";
import { Component } from "react";
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  Glyphicon,
  Modal,
  Nav,
  Navbar,
  NavItem,
  ProgressBar,
  Radio,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  IPdfPage,
  processFile,
  processFileURL,
  TIMEOUT,
  uploadFile,
  validatePDFFile,
} from "src/global";
import fs from "src/services/config/fbConfig";
import { IStatementNavbarProps, IStatementNavbarState } from "./interfaces";

export default class StatementNavbar extends Component<
  IStatementNavbarProps,
  IStatementNavbarState
> {
  public constructor(props: IStatementNavbarProps) {
    super(props);

    this.state = {
      loading: false,
      uploading: false,
      uploadMin: 0,
      uploadMax: 0,
      uploadValue: 0,
      showProcessFileOptions: false,
      importType: 0,
      showHelp: false,
    };

    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.processFile = this.processFile.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.deleteUploadedStatement = this.deleteUploadedStatement.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.uploadProgress = this.uploadProgress.bind(this);
    this.processFileOptionsModal = this.processFileOptionsModal.bind(this);
    this.cancelProcessFile = this.cancelProcessFile.bind(this);
    this.processPDFFile = this.processPDFFile.bind(this);
    this.renderHelpModal = this.renderHelpModal.bind(this);
    this.closeHelp = this.closeHelp.bind(this);
    this.showHelp = this.showHelp.bind(this);
    this.handleImportTypeChanged = this.handleImportTypeChanged.bind(this);
  }

  public componentWillMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    const savedGlyph = "glyphicon glyphicon-floppy-saved";
    const saveGlyph = "glyphicon glyphicon-floppy-save";
    return (
      <div className="subnavbar-container">
        <Navbar collapseOnSelect={true} inverse={false}>
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to={`/project/${projectId}`}>
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                {this.props.brand}
              </NavLink>
              {this.state.uploading ? (
                <ProgressBar
                  className="projects-navbar"
                  active={this.state.uploading}
                  min={this.state.uploadMin}
                  max={this.state.uploadMax}
                  now={this.state.uploadValue}
                />
              ) : null}
              {this.props.allowStatementUpload && this.props.uploaded ? (
                <h5>
                  <a href="#" onClick={this.downloadFile}>
                    {this.props.filename}
                  </a>
                </h5>
              ) : null}
            </Navbar.Brand>
            {this.props.allowStatementUpload || this.props.allowStatementParsing ? (
              <Navbar.Toggle />
            ) : null}
          </Navbar.Header>
          {this.props.allowStatementUpload ||
          this.props.allowStatementParsing ||
          this.props.needsSaving ? (
            <Navbar.Collapse>
              <Nav pullRight={true}>
                <NavItem style={{ margin: "3px" }}>
                  <Button
                    className="button-right"
                    bsStyle={this.props.needsSaving ? "success" : "default"}
                    bsSize="small"
                    disabled={!this.props.needsSaving} // tslint:disable-next-line:jsx-no-lambda
                    onClick={() => this.props.saveData(this.props.needsSaving)}
                  >
                    <Glyphicon glyph={this.props.needsSaving ? saveGlyph : savedGlyph} />{" "}
                    {this.props.needsSaving ? "Save " : "Saved "}
                  </Button>
                  <Button bsSize="small" bsStyle="success" onClick={this.showHelp}>
                    <Glyphicon glyph="glyphicon glyphicon-question-sign" /> Help
                  </Button>
                </NavItem>
              </Nav>
              <Nav className="nav-file-select" pullRight={true}>
                {/* <Navbar.Form> */}
                {this.props.allowStatementUpload || this.props.allowStatementParsing ? (
                  <FormGroup
                    className="statement-import"
                    style={{ padding: "0px", margin: "6px" }}
                    controlId="file"
                  >
                    <Col>
                      <FormControl
                        type="file"
                        accept="application/pdf"
                        onChange={this.handleFilenameChanged}
                      />
                    </Col>
                  </FormGroup>
                ) : null}
                {this.props.allowStatementUpload ? (
                  <Button
                    className="button-left button-top button-bottom"
                    disabled={this.props.file === null || this.props.uploaded}
                    bsStyle="primary"
                    bsSize="small"
                    onClick={this.uploadFile}
                  >
                    <Glyphicon glyph="glyphicon glyphicon-cloud-upload" /> Upload
                  </Button>
                ) : null}
                {this.props.allowStatementParsing || this.props.storagePath !== "" ? (
                  <Button
                    className="button-left button-top button-bottom"
                    disabled={
                      (this.props.file === null && this.props.storagePath === "") ||
                      !this.props.isAdvanced
                    }
                    bsStyle="primary"
                    bsSize="small"
                    onClick={this.processFile}
                  >
                    <Glyphicon glyph="glyphicon glyphicon-import" /> Import
                  </Button>
                ) : null}
                {this.props.allowStatementUpload ? (
                  <Button
                    className="button-left button-top button-bottom"
                    bsSize="small"
                    bsStyle="primary"
                    disabled={this.props.storagePath === "" && !this.props.uploaded}
                    onClick={this.downloadFile}
                  >
                    <Glyphicon glyph="glyphicon glyphicon-cloud-download" /> Download
                  </Button>
                ) : null}
                {this.props.allowStatementUpload ? (
                  <Button
                    className={`button-left button-top button-bottom`}
                    bsSize="small"
                    bsStyle="danger"
                    onClick={this.deleteUploadedStatement}
                    disabled={this.props.storagePath === "" && !this.props.uploaded}
                  >
                    <Glyphicon glyph="glyphicon glyphicon-remove" /> Remove
                  </Button>
                ) : null}
                {/* </Navbar.Form> */}
              </Nav>
            </Navbar.Collapse>
          ) : (
            <Nav pullRight={true}>
              <NavItem style={{ margin: "3px" }}>
                <Button
                  className="button-right"
                  bsStyle={this.props.needsSaving ? "success" : "default"}
                  bsSize="small"
                  disabled={!this.props.needsSaving} // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => this.props.saveData(this.props.needsSaving)}
                >
                  <Glyphicon glyph={this.props.needsSaving ? saveGlyph : savedGlyph} />{" "}
                  {this.props.needsSaving ? "Save " : "Saved "}
                </Button>
                <Button bsSize="small" bsStyle="success" onClick={this.showHelp}>
                  <Glyphicon glyph="glyphicon glyphicon-question-sign" /> Help
                </Button>
              </NavItem>
            </Nav>
          )}
        </Navbar>
        {this.processFileOptionsModal()}
        {this.renderHelpModal()}
      </div>
    );
  }

  private renderHelpModal() {
    return (
      <Modal show={this.state.showHelp} onHide={this.closeHelp} backdrop="static">
        <Modal.Header closeButton={true}>
          <Modal.Title>Statement Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li style={{ padding: "6px" }}>
              Import: This button will read the selected or uploaded file and read the text embedded
              in it. It will either use a hard-coded format based on a standard APS bill or an
              Eversource bill or use the configured field mappings to import the data.
            </li>
            <li style={{ padding: "6px" }}>
              Upload: When a file is initially selected, this button allows you to upload the file
              to the database and associated with this statement. If there is already a file already
              associated with the statement, you must first remove it before uploading a different
              file.
            </li>
            <li style={{ padding: "6px" }}>
              Download: If there is a file associated with the statement, this allows you to
              download that file. It will automatically be saved to the Downloads folder in most
              browsers unless the browser prompts you to save the file.
            </li>
            <li style={{ padding: "6px" }}>
              Remove: If there is a file associated with the statement, this will remove the file
              from the database. You will be prompted first.
            </li>
            <li style={{ padding: "6px" }}>
              Save: If there are no data changes, this button is disabled and shows the label of
              "Saved". If you make any changes, including importing data from a file, the button is
              enabled with a label of "Save".
              <ul>
                <li style={{ padding: "6px" }}>
                  Note: When you add a service charge or tax and fee, the item is immediately added
                  to the database. Individual edits are also immediately saved. This also applies to
                  removing either a service charge or tax and fee. The save button will also enable
                  during individual edits of the data in these tables as well.
                </li>
              </ul>
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="small" bsStyle="primary" onClick={this.closeHelp}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private showHelp() {
    this.setState({ showHelp: true });
  }

  private closeHelp() {
    this.setState({ showHelp: false });
  }

  private processFileOptionsModal() {
    return (
      <Modal
        show={this.state.showProcessFileOptions}
        onHide={this.cancelProcessFile}
        backdrop="static"
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>Select Process File Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <fieldset>
            <legend>Process Options</legend>
            <FormGroup bsSize="small" controlId="importType">
              <Radio
                value={0}
                name="importType"
                checked={this.state.importType === 0}
                onChange={this.handleImportTypeChanged}
              >
                APS Electric Bill
              </Radio>
              <Radio
                disabled={true}
                value={1}
                name="importType"
                checked={this.state.importType === 1}
                onChange={this.handleImportTypeChanged}
              >
                Eversource Electric Bill
              </Radio>
              <Radio
                disabled={true}
                value={2}
                name="importType"
                checked={this.state.importType === 2}
                onChange={this.handleImportTypeChanged}
              >
                Field Mappings
              </Radio>
            </FormGroup>
          </fieldset>
          <h5>
            Clicking Process below will read the selected or uploaded statement using the statement
            format specified. This processing will also overwrite any manually entered data in the
            statement.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="small" bsStyle="primary" onClick={this.processPDFFile}>
            Process
          </Button>
          <Button bsSize="small" bsStyle="danger" onClick={this.cancelProcessFile}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private processPDFFile(e: any) {
    e.preventDefault();

    this.setState({ showProcessFileOptions: false });
    if (this.props.file !== null) {
      processFile(this.props.file).then(pdfPages => {
        this.props.importPDFData(pdfPages, this.state.importType);
      });
    } else if (this.props.file === null && this.props.storagePath !== "") {
      let docUrl: string = "";
      fs.fsStorage
        .ref()
        .child(this.props.storagePath)
        .getDownloadURL()
        .then(url => {
          docUrl = url;
        })
        .then(() => {
          processFileURL(docUrl).then((pdfPages: IPdfPage[]) => {
            this.props.importPDFData(pdfPages, this.state.importType);
          });
        });
    }
  }

  private cancelProcessFile(e: any) {
    e.preventDefault();
    this.setState({ showProcessFileOptions: false });
  }
  private handleImportTypeChanged(e: any) {
    this.setState({ importType: Number(e.target.value) });
  }

  private handleFilenameChanged(e: any) {
    const pdfFile: File = e.target.files[0];
    if (pdfFile) {
      if (validatePDFFile(pdfFile)) {
        this.props.handleFilenameChanged(e);
      } else {
        alert("The selected file is not a valid PDF file.  Please select a PDF statement.");
        this.props.deleteUploadedStatement();
      }
    }
  }
  private processFile(e: any) {
    e.preventDefault();
    this.setState({ showProcessFileOptions: true });
  }
  private downloadFile(e: any) {
    e.preventDefault();
    if (this.props.storagePath !== "" && this.props.filename !== "") {
      fs.fsStorage
        .ref()
        .child(this.props.storagePath)
        .getDownloadURL()
        .then(url => {
          const xhr = new XMLHttpRequest();
          xhr.responseType = "arraybuffer";
          xhr.onloadend = event => {
            const downloadedFileBlob = new Blob([xhr.response], { type: "application/pdf" });
            const data = window.URL.createObjectURL(downloadedFileBlob);
            const link = document.createElement("a");
            link.href = data;
            link.download = this.props.filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(data);
            }, TIMEOUT);
          };
          xhr.open("GET", url);
          xhr.send();
        });
    }
  }
  private deleteUploadedStatement(e: any) {
    e.preventDefault();
    if (confirm("Are you sure you want to remove the stored statement?")) {
      const ref = fs.fsStorage.ref();
      const { appService } = this.props;
      const projectId = appService.getActiveProjectId();
      const id = this.props.match.params.id;
      const projectPath = `projects/${projectId}/${id}.pdf`;
      const fileRef = ref.child(projectPath);
      // Delete before upload if it exists
      fileRef
        .delete()
        .then(() => {
          this.props.deleteUploadedStatement();
        })
        .catch(() => {
          this.props.deleteUploadedStatement();
        });
    }
  }

  private uploadFile(e: any) {
    e.preventDefault();
    if (this.props.file !== null) {
      const { appService } = this.props;
      const projectId = appService.getActiveProjectId();
      uploadFile(
        projectId,
        this.props.match.params.id,
        this.props.file,
        this.uploadProgress,
        this.props.uploaded
      );
    }
  }

  private uploadProgress(enabled: boolean, min: number, max: number, value: number) {
    let storagePath: string = "";
    if (!enabled && value === max) {
      const { appService } = this.props;
      const projectId = appService.getActiveProjectId();
      const id = this.props.match.params.id;
      storagePath = `projects/${projectId}/${id}.pdf`;
      this.props.setStoragePath(storagePath, this.props.filename);
    }

    this.setState({
      uploading: enabled,
      uploadMin: min,
      uploadMax: max,
      uploadValue: value,
    });

    if (!enabled && value === max) {
      this.setState({ uploading: false });
      this.props.setUploadStatus(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/StatementNavbar.tsx